module.exports = __webpack_public_path__ + "media/images/icon-address-8ccf12fb227ae16894fc0e83732f89dc.svg";